/**
 * Grade de linhas com data — índice, "datas importantes", lista do dia.
 *
 * Quantas linhas desenhar vem de fora, decidido em milímetros por quem monta a
 * página. Antes eram 80 linhas fixas: numa caixa de 172 mm sobravam 60 linhas
 * escondidas pelo `overflow: hidden` e a última caixinha de data saía **cortada
 * ao meio** no pé da página — o mesmo defeito silencioso do calendário anual.
 *
 * A conta fica no motor, e não medida aqui, de propósito: o desenho é
 * determinístico, e medir no navegador falha justamente no caso que importa — a
 * área de impressão nasce com `display: none`, então na hora do layout não há
 * altura nenhuma para medir.
 */
export function GradeComData({
  passo,
  colunas,
  linhas,
  desenharLinha,
}: {
  /** Altura de cada linha, em milímetros. */
  passo: number;
  /** Quantas colunas de datas lado a lado. */
  colunas: number;
  /** Quantas linhas desenhar. */
  linhas: number;
  /** Desenha uma linha: recebe o índice. */
  desenharLinha: (indice: number) => React.ReactNode;
}) {
  return (
    <div
      style={{
        flex: '1 1 auto',
        minHeight: 0,
        overflow: 'hidden',
        display: 'grid',
        gridTemplateColumns: colunas > 1 ? `repeat(${colunas}, 1fr)` : undefined,
        columnGap: colunas > 1 ? '5mm' : undefined,
      }}
    >
      {Array.from({ length: Math.max(1, colunas) }).map((_, coluna) => (
        <div
          key={coluna}
          style={{
            display: 'grid',
            gridTemplateRows: `repeat(${linhas}, ${passo}mm)`,
            alignContent: 'start',
            minWidth: 0,
          }}
        >
          {Array.from({ length: linhas }).map((__, linha) => desenharLinha(linha))}
        </div>
      ))}
    </div>
  );
}
